import React, {
  SyntheticEvent,
  useCallback,
  useState,
  useEffect,
} from 'react';
import classNames from 'classnames';

import { useTranslateFn } from 'utils/useTranslateFn';
import styles from './styles.module.scss';

interface IStepperProps<Key extends string = string> {
  steps: Array<Key>,
  onClickStepper?: (stepTitle: Key) => boolean,
  step?: Key,
}

const Stepper = <Key extends string = string>({
  steps,
  onClickStepper,
  step,
  ...props
}: IStepperProps<Key>) => {
  const [currentStep, setCurrentStep] = useState<Key>(step || steps[0]);

  const t = useTranslateFn<Key>();

  const onStepHandler = useCallback((event: SyntheticEvent<HTMLDivElement>) => {
    const { title } = event.currentTarget.dataset;
    if (title && ((onClickStepper && onClickStepper(title as Key)) ?? true)) {
      setCurrentStep(title as Key);
    }
  }, [onClickStepper, setCurrentStep]);

  useEffect(() => {
    if (step) {
      setCurrentStep(step);
    }
  }, [step, setCurrentStep]);
  return (
    <div
      {...props}
      className={classNames(styles.steps, 'common-components-Stepper__steps')}
    >
      {steps.map((currStep, index) => (
        <div
          key={currStep}
          onClick={onStepHandler}
          onKeyDown={onStepHandler}
          data-title={currStep}
          className={classNames(styles.step, 'common-components-Stepper__step', {
            [styles.current]: currentStep === currStep,
            [styles.complete]: index < steps.indexOf(currentStep),
            'common-components-Stepper__step--current': currentStep === currStep,
            'common-components-Stepper__step--complete': index < steps.indexOf(currentStep),
          })}
          role="button"
          tabIndex={0}
        >
          <span className={classNames(styles.text, 'common-components-Stepper__text')}>{t(currStep as any)}</span>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
